import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    Button, Checkbox,
    Col,
    Divider,
    Form,
    Input,
    List,
    Modal,
    notification,
    Popconfirm,
    Row,
    Select,
    Space,
    Tag,
    Typography,
    Upload
} from "antd";

import {
    BranchesOutlined,
    DeleteOutlined,
    FileOutlined,
    InboxOutlined,
    LinkOutlined,
    MailOutlined,
    MessageOutlined,
    MinusCircleOutlined,
    WhatsAppOutlined
} from '@ant-design/icons';

import ApiService from "../../../services/ApiService"
import IntlMessage from "../../../components/util-components/IntlMessage";
import {API_BASE_URL, ASSET_BASE_URL} from "../../../configs/AppConfig";
import PdforImage from "../../../components/util-components/PdforImage";
import {configIsExist, getConfig} from "../../../components/permissions/functions";
import PermissionAlert from "../../../components/permissions/PermissionAlert";
import EmailTemplateField from "../../../components/custom-fields/EmailTemplateField";
import GSM_CALCULATOR from 'gsm';


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalEdit extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initState = {
        visible: false,
        loading: false,
        id: null,
        edit: false,
        defaultData: {},
        type: "WHATSAPP",
        categories: [],
        selectedCategories: [],
        allContact:false,
        target: 0,

        linkVisible: false,
        links: [],

        docVisible: false,
        initialDocs: [],
        docs: [],

        videoVisible: false,
        initialVideos: [],
        videos: [],

        virtual: false,
        virtualContacts: []
    };

    state = this.initState

    async show(data = null) {
        await this.init()

        if (data && data.virtualContacts) {
            this.setState({virtual: true, virtualContacts: data.virtualContacts})
        }

        if (data && data.id) {
            var newData = {...data}

            if (!newData.categories) {
                newData.categories = []
            }

            if (!newData.familles) {
                newData.familles = []
            }

            if (!newData.docs) {
                newData.docs = []
            }

            if (!newData.videos) {
                newData.videos = []
            }

            if (!newData.links) {
                newData.links = []
            }

            this.setState({
                visible: true,
                id: newData.id,
                defaultData: newData,
                edit: true,
                selectedCategories: newData.categories,
                selectedFamilles: newData.familles,
                links: newData.links,
                docs: newData.docs,
                initialDocs: newData.docs,
                videos: newData.videos,
                initialVideos: newData.videos,
                type: newData.type
            }, () => this.getTargets())
        } else {
            this.setState({visible: true, defaultData: {type: this.state.type}})
        }
    }

    onSearch = (text) => {
        this.setState({text});
    }

    close() {
        this.setState(this.initState)
    }

    componentDidMount() {
        this.init()
    }

    async init() {
        var res = await ApiService.get("/contact/categories")
        if (res.success) {
            this.setState({categories: res.items})
        }
    }


    async getTargets() {
        if (!this.form) {
            setTimeout(() => this.getTargets(), 500)
            return false
        }

        var res = await ApiService.post("/messages/targets", {
            categories: this.state.selectedCategories,
            allContact: this.state.allContact,
        })

        if (res.success) {
            this.setState({target: res.total})
        }
    }


    async onSubmit(data) {

        data.categories = this.state.selectedCategories
        data.allContact = this.state.allContact
        data.docs = this.state.docs
        data.videos = this.state.videos
        data.links = this.state.links

        if (data.type == "SMS") {
            data.docs = []
            data.videos = []
        }

        if (this.state.virtual) {
            data.virtualContacts = this.state.virtualContacts
            data.categories = []
            data.familles = []
        }

        if (!data.subject) {
            data.subject = ""
        }

        if(this.props.pe){
            data.pe=this.props.pe.id
        }
        if(this.props.peCloture){
            data.peCloture=true
        }

        if (this.state.edit && !this.state.id) {
            notification.error({
                message: (<Trans>Erreur lors de la modification</Trans>)
            })
            this.close()
            return false
        }

        if (this.state.edit) {
            data.id = this.state.id
        }

        var res = await ApiService.post("/messages/edit", data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? (<Trans>Modification réussie</Trans>) : (<Trans>Ajout réussi</Trans>)
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? (<Trans>Erreur lors de la modification</Trans>) : (<Trans>Erreur lors de l'ajout</Trans>)
            })
        }
    }


    addVariable(variable) {
        var message = this.form.getFieldValue("message") || ""
        message += variable
        this.form.setFieldValue("message", message)
    }

    render() {

        var defaultData = this.state.defaultData

        const emailAuth = getConfig("EmailAuth", "AUTH")
        const smsAuth = getConfig("SMSAuth", "AUTH")

        var emailConfigs = []
        if (emailAuth?.configs) {
            emailConfigs = emailAuth.configs
            if (!defaultData.emailConfig) {
                defaultData.emailConfig = emailConfigs[0].id
            }
        }

        var typeSelect = [
            (<Select.Option key={0} value={"WHATSAPP"}><Space><WhatsAppOutlined/> Whatsapp</Space></Select.Option>),
        ]

        if ((smsAuth && smsAuth.value)) {
            typeSelect.splice(2, 0, (
                <Select.Option key={1} value={"SMS"}><Space><MessageOutlined/> SMS</Space></Select.Option>))
            typeSelect.push(
                (
                    <Select.Option key={2} value={"WHATSAPP_OU_SMS"}><Space><BranchesOutlined/> Whatsapp ou SMS</Space></Select.Option>),
            )
        }

        if ((emailAuth && emailAuth.value)) {
            typeSelect.splice(2, 0, (
                <Select.Option key={3} value={"EMAIL"}><Space><MailOutlined/> Email</Space></Select.Option>))
            typeSelect.push((
                <Select.Option key={5} value={"WHATSAPP_OU_EMAIL"}><Space><BranchesOutlined/> Whatsapp ou Email</Space></Select.Option>),)
        }

        if ((smsAuth && smsAuth.value) && (emailAuth && emailAuth.value)) {
            typeSelect.push(
                (<Select.Option key={5} value={"SMS_OU_EMAIL"}><Space><BranchesOutlined/> SMS ou Email</Space></Select.Option>),
                (<Select.Option key={4} value={"WHATSAPP_OU_SMS_OU_EMAIL"}><Space><BranchesOutlined/> Whatsapp ou SMS ou Email</Space></Select.Option>),
            )
        }

        return (
            <Modal
                width="100%"
                title={this.state.edit ? t`Éditer une Campagne de Messages` : t`Ajouter une Campagne de Messages`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >

                <PermissionAlert permissions={["message.edit"]}>
                    <Form
                        ref={(ref) => this.form = ref}
                        initialValues={defaultData}
                        onFinish={(data) => this.onSubmit(data)}
                    >

                        <Divider><Trans>Cibles</Trans></Divider>

                        <Form.Item
                            label={<Trans>Canal</Trans>}
                            name="type"
                            rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                        >
                            <Select placeholder={t`Canal`} onChange={(value) => this.setState({type: value})}>
                                {typeSelect}
                            </Select>
                        </Form.Item>

                        {!this.state.virtual && (
                            <div>

                                <Form.Item>
                                    <Checkbox checked={this.state.allContact} onChange={(e)=>this.setState({allContact:e.target.checked},()=>this.getTargets())}>
                                        <Trans>Envoyer à tous mes contacts</Trans>
                                    </Checkbox>
                                </Form.Item>

                                <Form.Item
                                    label={<Trans>Catégories</Trans>}
                                >
                                    <Select
                                        disabled={this.state.allContact}
                                        mode="tags"
                                        placeholder={t`Catégories`}
                                        value={this.state.selectedCategories}
                                        onSelect={(value) => {
                                            var newArray = [...this.state.selectedCategories]
                                            newArray.push(value)
                                            this.setState({selectedCategories: newArray}, () => this.getTargets())
                                        }}
                                        onDeselect={(value) => {
                                            var newArray = [...this.state.selectedCategories]
                                            newArray.splice(newArray.indexOf(value), 1)
                                            this.setState({selectedCategories: newArray}, () => this.getTargets())
                                        }}
                                    >
                                        {this.state.categories.map((item, index) => <Select.Option key={index} value={item}>{item}</Select.Option>)}
                                    </Select>
                                </Form.Item>

                                <Text><Trans>Nombre de Contact</Trans> : {this.state.target}</Text>

                            </div>
                        )}

                        {this.state.virtual && (
                            <div>
                                <Divider><Trans>Contacts Virtuels</Trans></Divider>
                                <Form.Item label={`${this.state.virtualContacts.length} ${t`Contact(s) Virtuel`}`}>
                                    <div
                                        style={{
                                            maxHeight: 400,
                                            overflow: 'auto',
                                            padding: '0',
                                            border: '1px solid rgba(140, 140, 140, 0.35)',
                                        }}
                                    >
                                        <List
                                            bordered
                                            dataSource={this.state.virtualContacts}
                                            renderItem={(item, index) => {
                                                var email = item.email ? `(${item.email})` : ""
                                                var tel = item.tel ? `(${item.tel})` : ""
                                                return (
                                                    <List.Item key={index}>
                                                        <Space>
                                                            <Popconfirm
                                                                title={t`Êtes-vous sûrs de vouloir supprimer ce contact virtuel pour cette campagne ?`}
                                                                onConfirm={() => {
                                                                    var newArray = [...this.state.virtualContacts]
                                                                    newArray.splice(index, 1)
                                                                    this.setState({virtualContacts: newArray})
                                                                }}
                                                                okText={t`Oui`}
                                                                cancelText={t`Non`}
                                                                okType={"danger"}
                                                            >
                                                                <Button type={"text"} icon={<DeleteOutlined/>}/>
                                                            </Popconfirm>
                                                            <Text><Text strong>{item.nom} {item.prenom}</Text> {tel} {email}</Text>
                                                        </Space>
                                                    </List.Item>
                                                )
                                            }}
                                        />

                                    </div>
                                </Form.Item>
                            </div>
                        )}

                        <Divider><Trans>Contenu du Message</Trans></Divider>

                        <Col style={{marginBottom: 15}}>
                            <Text><Trans>Variables :</Trans>
                                <span style={{marginLeft: 20}}>
                                    <Tag style={{cursor: "pointer"}} color={"blue"} onClick={() => this.addVariable("{{nom}}")}><Trans>Nom</Trans></Tag>
                                    <Tag style={{cursor: "pointer"}} color={"blue"} onClick={() => this.addVariable("{{prenom}}")}><Trans>Prénom</Trans></Tag>
                                    <Tag style={{cursor: "pointer"}} color={"blue"} onClick={() => this.addVariable("{{prenomHE}}")}><Trans>Prénom Hébraïque</Trans></Tag>
                                </span>
                            </Text>
                        </Col>

                        <Form.Item
                            label={<Trans>Message</Trans>}
                            name="message"
                            rules={[
                                {
                                    required: (this.state.type == "EMAIL" || this.state.type == "WHATSAPP") ? false : true,
                                    message: t`Ce champ est obligatoire`
                                },
                                this.state.type.includes("SMS") ? {
                                    message: t`Ce message n'est pas au format GSM-7`,
                                    pattern: "^[A-Za-z0-9 \\r\\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!\"#$%&'()*+,\\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\\\\[~\\]|\u20AC]*$"
                                } : {}
                            ]}
                        >
                            <Input.TextArea
                                placeholder={t`Message`}
                                maxLength={this.state.type.includes("SMS") ? (600 - 11) : null}
                                autoSize={{minRows: 5}}
                                showCount={this.state.type.includes("SMS")}
                            />
                        </Form.Item>

                        {this.state.type.includes("EMAIL") && (
                            <Form.Item
                                label={<Trans>Objet du Mail</Trans>}
                                name="subject"
                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                            >
                                <Input placeholder={t`Objet du Mail`}/>
                            </Form.Item>
                        )}

                        {this.state.type.includes("EMAIL") && (
                            <Form.Item
                                label={<Trans>Modèle d'email</Trans>}
                                name="emailTemplate"
                            >
                                <EmailTemplateField/>
                            </Form.Item>
                        )}

                        {this.state.type.includes("EMAIL") && emailConfigs.length > 0 && (
                            <Form.Item
                                label={<Trans>Expéditeur (Email)</Trans>}
                                name="emailConfig"
                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                            >
                                <Select>
                                    {emailConfigs.map(i => (<Select.Option value={i.id}>{i.name}</Select.Option>))}
                                </Select>
                            </Form.Item>
                        )}

                        <Divider><Trans>Contenu Supplémentaire</Trans></Divider>

                        <Row style={{marginBottom: 20}}>
                            <Text><Trans>Liste des liens :</Trans></Text>

                            {this.state.links.length > 0 && (
                                <ul>
                                    {this.state.links.map((item, index) => (
                                        <li key={index} style={{marginTop: 8}}>
                                            <Button
                                                style={{marginRight: 8}}
                                                href={item.url}
                                                target="_blank"
                                                icon={<LinkOutlined/>}
                                            >
                                                {item.name}
                                            </Button>
                                            <MinusCircleOutlined
                                                onClick={() => {
                                                    var links = this.state.links
                                                    links.splice(index, 1)
                                                    this.setState({links: links})
                                                }}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {this.state.links.length == 0 && (
                                <Text style={{marginLeft: 8}}>
                                    <Trans>Aucun lien</Trans>
                                </Text>
                            )}
                        </Row>

                        <Button
                            htmlType="button"
                            type="dashed"
                            onClick={() => this.setState({linkVisible: true})}
                        >
                            <Trans>Ajouter un lien Web</Trans>
                        </Button>

                        {this.state.type != "SMS" && (
                            <Fragment>
                                <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                    <div style={{width: "60%"}}><Divider/></div>
                                </div>

                                <Row style={{marginBottom: 20, marginTop: 20}}>
                                    <Text><Trans>Documents :</Trans></Text>

                                    {this.state.docs.length > 0 && (
                                        <ul style={{marginTop: 20}}>
                                            {this.state.docs.map((item, index) => (
                                                <li key={index} style={{marginTop: 8}}>
                                                    <Button
                                                        style={{marginRight: 8}}
                                                        href={
                                                            this.state.initialDocs.find(
                                                                (i) => i.name == item.name && i.doc == item.doc
                                                            )
                                                                ? ASSET_BASE_URL + "/" + item.doc
                                                                : API_BASE_URL + "/upload/tmp/" + item.doc
                                                        }
                                                        target="_blank"
                                                        icon={<FileOutlined/>}
                                                    >
                                                        {item.name}
                                                    </Button>
                                                    <MinusCircleOutlined
                                                        onClick={() => {
                                                            var docs = this.state.docs
                                                            docs.splice(index, 1)
                                                            this.setState({docs: docs})
                                                        }}
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {this.state.docs.length == 0 && (
                                        <Text style={{marginLeft: 8}}>
                                            <Trans>Aucun Document</Trans>
                                        </Text>
                                    )}
                                </Row>

                                <Button
                                    htmlType="button"
                                    type="dashed"
                                    onClick={() => this.setState({docVisible: true})}
                                >
                                    <Trans>Ajouter un document</Trans>
                                </Button>

                                <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                    <div style={{width: "60%"}}><Divider/></div>
                                </div>

                                <Row style={{marginBottom: 20, marginTop: 20}}>
                                    <Text><Trans>Vidéos :</Trans></Text>

                                    {this.state.videos.length > 0 && (
                                        <ul style={{marginTop: 20}}>
                                            {this.state.videos.map((item, index) => (
                                                <li key={index} style={{marginTop: 8}}>
                                                    <Button
                                                        style={{marginRight: 8}}
                                                        href={
                                                            this.state.initialVideos.find(
                                                                (i) => i.name == item.name && i.doc == item.doc
                                                            )
                                                                ? ASSET_BASE_URL + "/" + item.doc
                                                                : API_BASE_URL + "/upload/tmp/" + item.doc
                                                        }
                                                        target="_blank"
                                                        icon={<FileOutlined/>}
                                                    >
                                                        {item.name}
                                                    </Button>
                                                    <MinusCircleOutlined
                                                        onClick={() => {
                                                            var videos = this.state.videos
                                                            videos.splice(index, 1)
                                                            this.setState({videos: videos})
                                                        }}
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {this.state.videos.length == 0 && (
                                        <Text style={{marginLeft: 8}}>
                                            <Trans>Aucune Vidéo</Trans>
                                        </Text>
                                    )}
                                </Row>

                                <Button
                                    htmlType="button"
                                    type="dashed"
                                    onClick={() => this.setState({videoVisible: true})}
                                >
                                    <Trans>Ajouter une vidéo</Trans>
                                </Button>
                            </Fragment>
                        )}

                        <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                <Trans>Enregistrer</Trans>
                            </Button>
                        </Form.Item>

                        <ModalLinks
                            visible={this.state.linkVisible}
                            onCancel={() => this.setState({linkVisible: false})}
                            onFinish={(data) => {
                                var links = this.state.links
                                links.push(data)
                                this.setState({links: links, linkVisible: false})
                            }}
                        />

                        <ModalDoc
                            visible={this.state.docVisible}
                            onCancel={() => this.setState({docVisible: false})}
                            onFinish={(data) => {
                                var docs = this.state.docs
                                docs.push(data)
                                this.setState({docs: docs, docVisible: false})
                            }}
                        />

                        <ModalVideo
                            visible={this.state.videoVisible}
                            onCancel={() => this.setState({videoVisible: false})}
                            onFinish={(data) => {
                                var videos = this.state.videos
                                videos.push(data)
                                this.setState({videos: videos, videoVisible: false})
                            }}
                        />


                    </Form>
                </PermissionAlert>
            </Modal>
        )
    }
}






const ModalLinks = ({visible, onCancel, onFinish}) => {
    const [form] = Form.useForm();
    const prevVisibleRef = useRef();

    useEffect(() => {
        prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;

    useEffect(() => {
        if (!visible && prevVisible) {
            form.resetFields();
        }
    }, [visible]);

    const onOk = () => {
        form.submit();
    };

    return (
        <Modal title={t`Ajouter un Lien`} open={visible} onOk={onOk} onCancel={onCancel}>
            <Form form={form} layout="vertical" name="LinkForm" onFinish={(data) => onFinish(data)}>
                <Form.Item
                    name="name"
                    label={<Trans>Nom du lien</Trans>}
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                >
                    <Input placeholder={t`Nom du lien`}/>
                </Form.Item>
                <Form.Item
                    name="url"
                    label={<Trans>Url</Trans>}
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                >
                    <Input placeholder={t`Url`} type="url"/>
                </Form.Item>
            </Form>
        </Modal>
    );
};


const ModalDoc = ({visible, onCancel, onFinish}) => {
    const [form] = Form.useForm();
    const prevVisibleRef = useRef();
    const [doc, setDoc] = useState(null)

    useEffect(() => {
        prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;

    useEffect(() => {
        if (!visible && prevVisible) {
            form.resetFields();
        }
    }, [visible]);

    const onOk = () => {
        form.submit();
    };

    return (
        <Modal title={t`Ajouter un Document`} open={visible} onOk={onOk} onCancel={() => {
            setDoc(null)
            onCancel()
        }}>
            <Form form={form} layout="vertical" name="LinkForm" onFinish={(data) => {
                data.doc = doc
                setDoc(null)
                onFinish(data)
            }}>
                <Form.Item
                    name="name"
                    label={<Trans>Nom du document</Trans>}
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                >
                    <Input placeholder={t`Nom du document`}/>
                </Form.Item>

                <Form.Item
                    label={<Trans>Document</Trans>}
                    name="doc"
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    shouldUpdate
                >
                    {!doc && (
                        <Upload.Dragger
                            name="doc"
                            multiple={false}
                            accept="image/*,application/pdf"
                            onChange={({file}) => {
                                if (file.response && file.status == "done") {
                                    setDoc(file.response)
                                    form.setFieldValue("doc", file.response)
                                }
                            }}
                            headers={{authorization: localStorage.getItem("AUTH_TOKEN")}}
                            action={API_BASE_URL + "/upload/doc"}
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined/>
                            </p>
                            <p className="ant-upload-text">
                                <Trans>Cliquez ou faites glisser le fichier dans cette zone pour le télécharger</Trans>
                            </p>
                            <p><Trans>Image / Pdf</Trans></p>
                        </Upload.Dragger>
                    )}

                    {doc && (
                        <Row style={{justifyContent: "flex-start", alignItems: "flex-start"}}>
                            <PdforImage url={ASSET_BASE_URL + "/" + doc}/>
                            <Button type="danger" style={{marginLeft: 8}} icon={<DeleteOutlined/>} onClick={() => {
                                setDoc(null)
                                form.setFieldValue("doc", null)
                            }}/>
                        </Row>
                    )}
                </Form.Item>

            </Form>
        </Modal>
    );
};


const ModalVideo = ({visible, onCancel, onFinish}) => {
    const [form] = Form.useForm();
    const prevVisibleRef = useRef();
    const [doc, setDoc] = useState(null)

    useEffect(() => {
        prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;

    useEffect(() => {
        if (!visible && prevVisible) {
            form.resetFields();
        }
    }, [visible]);

    const onOk = () => {
        form.submit();
    };

    return (
        <Modal title={t`Ajouter une Video`} open={visible} onOk={onOk} onCancel={() => {
            setDoc(null)
            onCancel()
        }}>
            <Form form={form} layout="vertical" name="LinkForm" onFinish={(data) => {
                data.doc = doc
                setDoc(null)
                onFinish(data)
            }}>
                <Form.Item
                    name="name"
                    label={<Trans>Nom de la video</Trans>}
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                >
                    <Input placeholder={t`Nom de la video`}/>
                </Form.Item>

                <Form.Item
                    label={<Trans>Video</Trans>}
                    name="doc"
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    shouldUpdate
                >
                    {!doc && (
                        <Upload.Dragger
                            name="doc"
                            multiple={false}
                            accept="video/*"
                            onChange={({file}) => {
                                if (file.response && file.status == "done") {
                                    setDoc(file.response)
                                    form.setFieldValue("doc", file.response)
                                }
                            }}
                            headers={{authorization: localStorage.getItem("AUTH_TOKEN")}}
                            action={API_BASE_URL + "/upload/video"}
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined/>
                            </p>
                            <p className="ant-upload-text">
                                <Trans>Cliquez ou faites glisser le fichier dans cette zone pour le télécharger</Trans>
                            </p>
                            <p><Trans>Video</Trans></p>
                        </Upload.Dragger>
                    )}

                    {doc && (
                        <Row style={{justifyContent: "flex-start", alignItems: "flex-start"}}>
                            <video src={API_BASE_URL + "/upload/tmp/" + doc} playsInline muted autoPlay
                                   style={{maxWidth: "30%"}}/>
                            <Button type="danger" style={{marginLeft: 8}} icon={<DeleteOutlined/>} onClick={() => {
                                setDoc(null)
                                form.setFieldValue("doc", null)
                            }}/>
                        </Row>
                    )}
                </Form.Item>

            </Form>
        </Modal>
    );
};

